import { EdTabsHeaderOption } from '@/models/ed-tabs-header-option.model';
import { PRIVATE_ROUTES } from '@/app/private/private.routes';

export const SECTION_OPTION_MODE = {
  COMMON: 'COMMON',
  STRICT: 'STRICT'
}

export const COURSE_API = {
  GET_COURSE_INFO: 'content/{courseId}/detail',
  GET_COURSE_CLASS_INFO: 'content/{courseId}/detail?classId={classId}',
  GET_COURSE_EDITION: 'content/course/{courseId}',
  GET_COURSE_SECTIONS: 'content/{courseId}/structure/text',
  GET_COURSE_DOWNLOADABLE_RESOURCES: 'content/{courseId}/downloadableResources',
  GET_COURSES_LIST: 'classes/myClassContents?page={page}&pageSize={pageSize}',
  SET_TEACHER_ONLY: 'content/{courseId}/section/{sectionId}/teacherOnly?teacherOnly={teacherOnly}',
  GET_CONTENT_BY_EDITOR: 'content/{courseId}/structure/textByEditor',
  OBTAIN_COURSES_BY_CLASS: 'classes/{classId}/getCoursesByClassAndOwner',
  GET_GRADING_DETAILS: 'homework/{classId}/content/{courseId}/gradingDetails',
  /* Create/Update Course */
  GET_COURSE_CATEGORIES: 'organization/categories?organizationId={orgId}',
  CREATE_COURSE: 'content/upload/course',
  UPDATE_COURSE: 'content/upload/course/{courseId}',
  /* Section objects */
  CREATE_SECTION: 'content/upload/{courseId}/section/{parentId}/object',
  EDIT_SECTION: 'content/{courseId}/structure',
  REMOVE_SECTION: 'content/{courseId}/structure/{sectionId}',
  REORDER_SECTION: 'content/{courseId}/structure/orderAfter',
  REMOVE_FILE: 'content/{courseId}/structure/{sectionId}/object/{sectionText}',
  REMOVE_IMAGE: 'content/{courseId}/structure/{sectionId}/object/{hash}',
  CREATE_SECTION_FROM_OBJECT: 'content/upload/{courseId}/section/{parentId}/object',
  EDIT_COURSE_MATERIAL_OBJECT: 'content/{courseId}/section/material',
  STATE_SECTION_FILES: 'content/{courseId}/section/{sectionId}?classId={classId}',
  GET_SECTION_TREE: 'content/{courseId}/section/{sectionId}/tree',
  CREATE_SUBDECK_SECTION: 'content/upload/{courseId}/section/{parentId}/object',
  GET_LOG_FROM_UPLOAD_ZIP: 'content/structure/{sectionId}/uploadZipLog',
  /* Course Materials */
  CREATE_COURSE_MATERIAL: 'content/upload/{courseId}/material',
  EDIT_COURSE_MATERIAL: 'content/{courseId}/material/{materialId}',
  REMOVE_COURSE_MATERIAL: 'content/{courseId}/material/{materialId}',
  MOVE_COURSE_MATERIAL: 'content/{courseId}/material/{materialId}/section',
  CREATE_MATERIAL_SECTION: 'content/{courseId}/material/section',
  EDIT_MATERIAL_SECTION: 'content/{courseId}/material/section/{sectionId}/rename',
  REMOVE_MATERIAL_SECTION: 'content/{courseId}/material/section/{sectionId}',
  MOVE_MATERIAL_SECTION: 'content/{courseId}/material/section/{materialSectionId}/move',
  STATE_COURSE_MATERIAL: 'content/{courseId}/material/{materialId}',
  UPDATE_SECTION_MATERIAL_VISIBILITY: 'content/{courseId}/material/section/{sectionId}?teacherOnly={teacherOnly}&saveMessageTeacherOnly={saveMessageTeacherOnly}',
  /* Subject Projects */
  CREATE_PROJECT: 'content/project/',
  UPDATE_PROJECT: 'content/project/{projectId}',
  REMOVE_PROJECT: 'content/project/{projectId}/content/{courseId}',
  REORDER_PROJECT: 'content/project/orderAfter/{projectAfterId}',
  SAVE_PROJECT_FILES: 'content/project/sections',
  /* Subject Builder */
  GET_SUBJECT_BUILDER: 'course/builder/upload/{templateId}/build',
  RUN_SUBJECT_BUILDER: 'course/builder/{templateId}/run',
  GET_FROM_SUBJECT_BUILDER: 'course/builder/{templateId}/log',
  GET_SUBJECT_CALENDAR: 'content/{contentId}/structure/calendar',
  GET_BUILDER_ALL_LESSONS: 'content/{contentId}/structure/{rootFixedSection}',
  GET_BUILDER_BACKUP: 'course/builder/{templateId}/build/{resourceId}',
  GET_BUILDER_QUICK_SUBJECT: 'course/builder/{templateId}/build/{resourceId}',
  SYNC_BUILDER_DATA: 'course/builder/upload/{builderId}/sync',
  DOWNLOAD_SUBJECT_BUILDER: 'course/builder/{builderId}/download',
  /* Components */
  CREATE_EDUAC_COMPONENT: 'component/',
  UPDATE_EDUAC_COMPONENT: 'component/',
  REMOVE_EDUAC_COMPONENT: 'component/{componentId}',
  /* Decks Library */
  CREATE_DECK: 'content/{contentId}/structure/deck',
  UPDATE_DECK: 'content/{contentId}/structure/deck/{deckId}',
  REMOVE_DECK: 'content/{courseId}/structure/deck/{deckId}',
  CREATE_CARD: 'content/upload/{contentId}/structure/{deckId}/card',
  UPDATE_CARD: 'content/upload/{contentId}/structure/card/{cardId}',
  REMOVE_CARD: 'content/{courseId}/structure/card/{cardId}',
  MOVE_CARD: 'content/{contentId}/structure/card/{cardId}/move',
  CREATE_SUB_DECK: 'content/{contentId}/structure/subdeck',
  UPDATE_SUB_DECK: 'content/{contentId}/structure/subdeck/{subDeckId}',
  BUILD_SUBJECT_FROM_TEMPLATE: 'course/builder/upload/{templateId}/create',
};

export const COURSE_STORE_NAME = 'CourseStore';

export const COURSE_STORE = {
  NAME: COURSE_STORE_NAME
}

export const _COURSE_STORE = COURSE_STORE;

export const COURSE_STORAGE_KEYS = {
  EXPIRED_TIME_CONFIRM_REMOVE_MATERIAL_SECTION: 'EXPIRED_TIME_CONFIRM_REMOVE_MATERIAL_SECTION',
  ED_COURSE_VIEWER_FOLDERS_STATE: 'ED_COURSE_VIEWER_FOLDERS_STATE',
  ED_COURSE_VIEWER_SECTION_STATE: 'ED_COURSE_VIEWER_SECTION_STATE',
  ED_COURSE_VIEWER_MATERIAL_STATE: 'ED_COURSE_VIEWER_MATERIAL_STATE',
  ED_COURSE_VIEWER_PROJECT_STATE: 'ED_COURSE_VIEWER_PROJECT_STATE'
}

export const COURSE_MATERIAL_KEYS = {
  SPLICE: 'SPLICE',
  CONTINUE: 'CONTINUE'
}

export const FILE_TO_WRITE_OBJECT = {
  FILE: 'FILE',
  COURSE_MATERIAL: 'COURSE_MATERIAL',
}

export const ANNOTATION_TYPES = {
  PDF_ANNOTATION: 'PDF_ANNOTATION'
}

export const COURSE_PAGE = {
  PORTAL: 'PORTAL_PAGE',
  EDIT_CONTENT: 'EDIT_CONTENT_PAGE'
}

export const COMPONENT_TYPE = {
  OBJECT_PREVIEW: {
    code: 'OBJECT_PREVIEW',
    viewer: 'EdObjectPreview'
  },
  LESSON_CREATOR: {
    code: 'LESSON_CREATOR',
    viewer: 'EdLessonCreator'
  },
  LESSON_MATERIAL_CREATOR: {
    code: 'LESSON_MATERIAL_CREATOR',
    viewer: 'EdSectionMaterialCreator'
  },
  PROJECT_CREATOR: {
    code: 'PROJECT_CREATOR',
    viewer: 'EdProjectCreator'
  },
  ED_CONTENT_SUBJECT_CALENDAR: {
    code: 'ED_CONTENT_SUBJECT_CALENDAR',
    viewer: 'ed-content-subject-calendar'
  },
  DECK_CREATOR: {
    code: 'DECK_CREATOR',
    viewer: 'EdDeckLibraryCreator'
  },
  DECK_VIEWER: {
    code: 'DECK_VIEWER',
    // viewer: 'EdDeckLibraryViewer'
    viewer: 'EdDeckViewerContainer'
  },
  CARD_CREATOR: {
    code: 'CARD_CREATOR',
    viewer: 'EdCardCreate'
  },
  HOMEWORK_TEACHER_SECTION_PERSON_COURSE_VIEWER: {
    code: 'HOMEWORK_TEACHER_SECTION_PERSON_COURSE_VIEWER',
    viewer: 'EdHomeworkTeacherSectionPersonCourseViewer',
  },
}

export const COURSE_MODE = {
  VIEW: 'VIEW',
  EDITION: 'EDITION'
}

export const COURSE_TABS = {
  COURSE_OBJ: 'courseObj',
  COURSE_ID: 'courseId',
  COURSE_TAB: 'COURSE_TAB',
  TASKS_TAB: 'TASKS_TAB',
  MAIN_TAB: 'MAIN_TAB',
  ED_PORTAL_TAB: 'ED_PORTAL_TAB',
  CLASS_ID: 'classId',
  ORG_ID: 'orgId'
}

export const COURSE_MATERIAL_AUDIO_FILES_TYPES: string[] = ['audio/mpeg','audio/x-wav'];
export const COURSE_MATERIAL_VIDEO_FILES_TYPES: string[] = ['video/mp4'];

export const COURSE_MATERIAL_AUDIO_FILES_SUBTYPE = 'AUDIO';
export const COURSE_MATERIAL_VIDEO_FILES_SUBTYPE = 'VIDEO';

export const MULTIMEDIA_FILES_TYPES_EXT = {
  'audio/mpeg': '.mp3',
  'audio/wav': '.wav',
  'audio/x-wav': '.wav',
  'video/mp4' : '.mp4',
}

export const BUILDER_DAY_OPTIONS = {
  OBSERVED: 'OBSERVED', // Holiday or special days taken as non-working day
  IGNORED: 'IGNORED',   // Holiday or special days taken as regular working day
  FUN: 'FUN',
  NOTIFIED: 'NOTIFIED'  // Events, regular working day
}

export const BUILDER_EVENT_TYPES = {
  CONTENT: 'CONTENT',
  FUN: 'FUN',
  FILLER: 'FILLERS',
  ADDITIONAL: 'ADDITIONAL',
  HOLIDAY: 'HOLIDAY',
  DAY_OFF: 'DAY_OFF',
  FIRST_SCHOOL_CALENDAR: 'FIRST_SCHOOL_CALENDAR',
  LAST_SCHOOL_CALENDAR: 'LAST_SCHOOL_CALENDAR',
  LESSON: 'LESSON'
}

export const BUILDER_CALENDAR_TYPES = {
  CALENDAR: 'CALENDAR',
  LESSONS: 'LESSONS'
}

export const BUILDER_LESSON_STATUS = {
  PENDING: 'PENDING',
  ASSIGNED: 'ASSIGNED',
  FIXED: 'FIXED',
}

export const BUILDER_STATUS = {
  DRAFT: 'DRAFT',
  PENDING: 'PENDING',
  DONE: 'READY',
  CONFLICT: 'CONFLICT',
}

export const BUILDER_SYNC_STATUS = {
  DONE: 'DONE',
  PENDING: 'PENDING',
  OUT: 'OUT',
  CONFLICT: 'CONFLICT',
  PROCESS: 'PROCESS',
  READY_DOWNLOAD: 'READY_DOWNLOAD',
  UPLOADING: 'UPLOADING'
}

export const BUILDER_SCHOOL_DAY_TYPES = {
  ORG: 'ORG',
  CLASS: 'CLASS',
  SUBJECT: 'SUBJECT'
}

export const BUILDER_MENU_V2: EdTabsHeaderOption[] = [
  {
    id: 1,
    active: true,
    path: '',
    name: 'subject-builder',
    label: 'subjectDescription',
    disabled: false,
  },
  {
    id: 2,
    active: false,
    path:  '',
    name: 'subject-calendar',
    label: 'lessons',
    disabled: false,
  },
  {
    id: 3,
    active: false,
    path:  '',
    name: 'subject-editor',
    label: 'editor',
    disabled: false,
  },
];

export const BUILDER_MENU: EdTabsHeaderOption[] = [{
  id: 1,
  active: true,
  path: '',
  name: 'subject-builder',
  label: 'subjectDescription_legacy',
  disabled: false,
},{
  id: 2,
  active: false,
  path:  '',
  name: 'subject-calendar',
  label: 'calendar_legacy',
  disabled: false,
},{
  id: 3,
  active: false,
  path:  '',
  name: 'subject-lessons',
  label: 'subjectLessons_legacy',
  disabled: false,
}
];

export const BUILDER_RULES = {
  ADD_FUN_LESSON: 'ADD_FUN_LESSON',
  REMOVE_FUN_LESSON: 'REMOVE_FUN_LESSON',
  SHIFT_DAY_BACK_WITH_DAY_OFF: 'SHIFT_DAY_BACK_WITH_DAY_OFF',
  SHIFT_DAY_BACK: 'SHIFT_DAY_BACK',
  SHIFT_OF_THE_FEATURE: 'SHIFT_OF_THE_FEATURE',
  SHIFT_OF_THE_FEATURE_WITHOUT_USE_LESSON: 'SHIFT_OF_THE_FEATURE_WITHOUT_USE_LESSON',
  SWAP_LESSONS: 'SWAP_LESSONS',
  START_LESSON: 'START_LESSON',
  PLACE_LABELS_ON_WORKING_DAY: 'PLACE_LABELS_ON_WORKING_DAY',
  MOVE_LESSON_WHEREVER: 'MOVE_LESSON_WHEREVER',
  REMOVE_PLACE_LABEL: 'REMOVE_PLACE_LABEL',
  REMOVE_START_LESSON: 'REMOVE_START_LESSON'
}

export const BUILDER_TAGS = {
  TEST: 'TEST',
  HOMEWORK: 'HOMEWORK',
  CLASSWORK: 'CLASSWORK'
}
//Days of weak ordered by day number order.  Do not modify the order
export const DAYS_OF_WEEK = [
  'SUNDAY', 
  'MONDAY', 
  'TUESDAY', 
  'WEDNESDAY', 
  'THURSDAY', 
  'FRIDAY', 
  'SATURDAY'];

export const MONTH_OF_YEAR = [
  'January', 
  'February', 
  'March', 
  'April', 
  'May', 
  'June', 
  'July', 
  'August', 
  'September', 
  'October',
  'November',
  'December'];
